import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  signal,
  WritableSignal,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-prime-grid-filter-toolbar',
  templateUrl: './prime-grid-filter-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrimeGridFilterToolbarComponent {
  hasFilter: InputSignal<boolean> = input(false);
  isCollapse: WritableSignal<boolean> = signal(true);

  toggleHandler(): void {
    this.isCollapse.set(!this.isCollapse());
  }
}
